import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';

// Tabs
import ProfileTab from "./Tabs/Profile";
import WorkingHoursTab from "./Tabs/WorkingHours";
// import SecurityTab from "./Tabs/Security";

  const tabContent = [
    {panel: "profile", content: <ProfileTab />},
    {panel: "repairs", content: <ProfileTab />},
    {panel: "appointments", content: <ProfileTab />},
    {panel: "working_hours", content: <WorkingHoursTab />},
  ]

const ViewStylist = () => {

  const tabs = [
    {label: "Profile", icon: <ContactPageOutlinedIcon fontSize="small" />},
    {label: "Repairs", icon: <ContentCutRoundedIcon fontSize="small" />},
    {label: "Appointments", icon: <CalendarMonthRoundedIcon fontSize="small" />},
    {label: "Working Hours", icon: <WorkHistoryRoundedIcon fontSize="small" />}
  ];

  return (
    <ViewDetails title="Stylist" identifier="full_name" tabs={tabs} tabContent={tabContent} isProfile={true} url="stylists">

    </ViewDetails>
  )
};

export default ViewStylist;